import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreImagePipe } from './store-image.pipe';
import { TextFormatPipe } from './text-format.pipe';
import { NhsErrorMessagePipe } from './nhs-error-message.pipe';

/** Shared declarative pipes for feature modules and {@link ComponentsModule}. */
@NgModule({
  declarations: [StoreImagePipe, TextFormatPipe],
  exports: [StoreImagePipe, TextFormatPipe, NhsErrorMessagePipe],
  imports: [CommonModule, NhsErrorMessagePipe],
})
export class PipesModule {}
